/**
 * Profile Download Center has 7 basic elements are:
 *  Inline, Description, DataTableView, StatList, StatListBox, Map, Header, Footer
 *
 * All dispay elements have to have a string type that links
 * the dynamic component to something JSON serializable in
 * the store
 */
export const displayElementKeys = {
    Header: "Header",
    Footer: "Footer",

    AmendmentInlineSection: "AmendmentInlineSection",
    BillInlineSection: "BillInlineSection",
    // BulkEmailInlineSection
    CampaignInlineSection: "CampaignInlineSection",
    CaucusInlineSection: "CaucusInlineSection",
    CommitteeInlineSection: "CommitteeInlineSection",
    CustomEventInlineSection: "CustomEventInlineSection",
    DocumentInlineSection: "DocumentInlineSection",
    EventInlineSection: "EventInlineSection",
    GrassrootsActionInlineSection: "GrassrootsActionInlineSection",
    ListInlineSection: "ListInlineSection",
    IssueInlineSection: "IssueInlineSection",
    IssueManagementInlineSection: "IssueManagementInlineSection",
    NoteInlineSection: "NoteInlineSection",
    OfficialInlineSection: "OfficialInlineSection",
    PublicOrganizationInlineSection: "PublicOrganizationInlineSection",
    PersonInlineSection: "PersonInlineSection",
    PressContactInlineSection: "PressContactInlineSection",
    RegulationInlineSection: "RegulationInlineSection",
    SponsorInlineSection: "SponsorInlineSection",
    StafferInlineSection: "StafferInlineSection",
    SupporterInlineSection: "SupporterInlineSection",
    VoteInlineSection: "VoteInlineSection",
    VoteResultInlineSection: "VoteResultInlineSection",
    OutboxInlineSection: "OutboxInlineSection",
    ArticleInlineSection: "ArticleInlineSection",

    TimelineSection: "TimelineSection",
    GeoTableSection: "GeoTableSection",
    StatusSection: "StatusSection",
    DescriptionSection: "DescriptionSection",
    PrioritySection: "PrioritySection",
    StanceSection: "StanceSection",
    AssignmentSection: "AssignmentSection",
    CustomNotesSection: "CustomNotesSection",
    ProfileImageSection: "ProfileImageSection",
    CustomImageSection: "CustomImageSection",
    EmptyState: "EmptyState",

    DataTableView: "DataTableView",
    CensusStats: "CensusStats",
    CustomData: "CustomData",
    LegislativeStats: "LegislativeStats",
    IssueStats: "IssueStats",
    RelationshipStats: "RelationshipStats",

    MapSection: "MapSection",
    ProfileAlignmentSection: "ProfileAlignmentSection",
}

export default displayElementKeys
